export default "__VITE_ASSET__49HEB8gx__"